import React from 'react'
import { cn } from '../../utils/cn'

interface CardProps {
  children: React.ReactNode
  className?: string
  padding?: boolean
}

const Card: React.FC<CardProps> = ({ 
  children, 
  className,
  padding = true 
}) => {
  return (
    <div className={cn(
      'bg-dark-900 rounded-lg border border-dark-700 shadow-lg',
      padding && 'p-6',
      className
    )}>
      {children}
    </div>
  )
}

export default Card
